<template>
    <div class="action-tracker-group-container">
        <div v-for="(group, index) in severityGroups" :key="group.severity" class="action-tracker-group" :style="{ position: isTrial ? 'relative' : '' }">
            <div class="action-tracker-key row">
                <div :class="['circle', 'circle-'+group.color]"></div>
                <h4>{{group.title}}</h4>
            </div>
            <table class="table table-striped action-tracker-table">
                <thead>
                    <tr>
                        <th v-if="!groupBySeverity" class="ac-col-1">
                            Aud. Idx
                            <span v-on:click="$emit('onSort', 'question_auditor_index', index)" class="sort-button fa fa-sort"
                                v-bind:class="{[currentSortActiveDirection] : sortColumn == 'question_auditor_index'}"></span>
                        </th>
                        <th class="ac-col-2">
                            Business Key
                            <span v-on:click="$emit('onSort', 'parent', index)" class="sort-button fa fa-sort"
                                v-bind:class="{[currentSortActiveDirection] : sortColumn == 'parent'}"></span>
                        </th>
                        <th class="ac-col-5">
                            Question Action
                            <span v-on:click="$emit('onSort', 'question', index)" class="sort-button fa fa-sort"
                                v-bind:class="{[currentSortActiveDirection] : sortColumn == 'question'}"></span>
                        </th>
                        <th class="ac-col-225">
                            Your Answer
                            <span v-on:click="$emit('onSort', 'value', index)" class="sort-button fa fa-sort"
                                v-bind:class="{[currentSortActiveDirection] : sortColumn == 'value'}"></span>
                        </th>
                        <th>
                            Status
                            <span v-on:click="$emit('onSort', 'status', index)" class="sort-button fa fa-sort"
                                v-bind:class="{[currentSortActiveDirection] : sortColumn == 'status'}"></span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <template v-for="(answer, index) in group.answers">
                  <tr v-if="!isTrial || index < 3" v-on:click="$emit('onEditAnswer', answer.question_id)" :key="answer.id">
                    <th v-if="!groupBySeverity" scope="row">
                      <p>{{ answer.question_auditor_index }}</p>
                    </th>
                    <th scope="row">
                      <p>{{ answer.parent }}</p>
                      <span>{{ answer.section }}</span>
                    </th>
                    <td>
                      <p>{{ answer.question }}</p>
                    </td>
                    <td>
                      <p> {{ answer.answer }}</p>
                      <span class="answer-data">{{formatDate(answer.created_at, answer.updated_at)}}</span>
                    </td>
                    <td>
                      <div class="status-container">
                        <div v-if="checkCorrectlyAnsweredStatus(answer)">
                          <span class="status-track status-marks-completed"><i class="far fa-check"></i> Correctly Answered</span>
                        </div>
                        <div v-else>
                          <p v-if="checkCorrectlyAnsweredValue(answer)" class="status-track status-marks-completed"><i class="far fa-check"></i> Correctly Answered</p>
                          <p v-else-if="checkNAAnsweredValue(answer)">N/A</p>
                          <p v-else>Target Remedy<br />{{ formatTargetRemedyDate(answer.target_remedy) }} </p>
                          <span class="status-track" :class="getStatusClass(answer.status)">{{ answer.status }}</span>
                        </div>
                        <i v-if="answer.notes + answer.auditor_notes > 0" class="fal fa-file-edit"></i>
                        <i v-if="answer.documents > 0" class="fal fa-files"></i>
                        <i v-if="answer.checkpoints > 0" class="fa fa-check-square-o"></i>
                        <i v-if="answer.archived === 1" class="fa fa-archive"></i>
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
            </table>
            <div v-if="!showCompleted[group.severity] && completedCount[group.severity] > 0" class="row justify-content-center view-completed"><a v-on:click="$emit('onShowCompletedAnswers', group)">{{group.completedLinkTitle}}</a></div>

          <div class="gradient-cover-trial" v-if="isTrial">
            <a href="/account/upgrade" target="_blank">
              Upgrade to see more
              <br>
              <span>
                If you want to access greater audit and benchmarking functionality including actions/steers/alerts/good practice to improve your training and competence, governance, risk, and compliance scores, plus gain integrations to relevant back-office tech you can upgrade to and choose a more comprehensive and relevant Model Office AI RegTech platform - to find out more click here
              </span>
            </a>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['groupBySeverity', 'severityGroups', 'severityLabels', 'selectedFilters', 'sortColumn', 'sortDir', 'showCompleted', 'completedCount', 'isTrial', 'showNaAnswers'],
        data() {
            return {
                currentSortActiveDirection: 'active fa-sort-desc',
            }
        },
        watch: {
            sortDir: function(newVal, oldVal) {
                this.currentSortActiveDirection = newVal == 'desc' ? 'active fa-sort-desc' : 'active fa-sort-asc';
            },
        },
        methods: {

            formatDate: function (created_at, updated_at) {
                let date = null;
                if (created_at || updated_at) {
                    if (created_at) {
                        date = created_at;
                    } else {
                        date = updated_at;
                    }
                    date = moment(date, "YYYY-MM-DD h:imm:ss").format("DD.MM.YYYY");
                }

                return date;
            },
            formatTargetRemedyDate: function (date) {
                return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
            },
            getStatusClass: function (status) {
                if (status == 'On Track') return 'status-marks-on-track';
                if (status == 'Delayed') return 'status-marks-delayed';
                if (status == 'Severely Delayed') return 'status-marks-severely-delayed';
                if (status == 'Completed') return 'status-marks-completed';
            },

            checkCorrectlyAnsweredStatus(answer){
              return answer.initially_correct ?? false;
            },

            checkCorrectlyAnsweredValue(answer){
              return answer.correctly_answered ?? false;
            },

            checkNAAnsweredValue(answer){
              return !this.showNaAnswers && answer.answer == 'N/A';
            } ,
        }
    }
</script>